import React, { Component } from 'react';
import { Field } from 'redux-form';
import { UpgradeOptionsCheckbox } from '../UpgradeOptionsCheckbox/index';
import { InfoButton } from '../../../../../../common/components/index';
import displayCurrency from '../../../../../../helpers/displayCurrency';
import { get } from 'lodash';
import './styles.scss';

export default class PolicyUpgradesBox extends Component {
  render() {
    const { isGold, boltOns, product, options } = this.props;
    const metaPolicyUpgrade = 'data.attributes.metadata.options';
    const travelDispute = get(boltOns, 'travel_dispute');
    const endSupplier = get(boltOns, 'end_supplier_failure');
    const smartLuggage = get(boltOns, 'smart_luggage');
    const b2bDefinitions =
      product.resources[product.productId].data.attributes.metadata.definitions.b2b;
    const travelDisputeText = b2bDefinitions ? b2bDefinitions.travel_dispute : false;
    const endSupplierText = b2bDefinitions ? b2bDefinitions.end_supplier_failure : false;
    const smartLuggageText = b2bDefinitions ? b2bDefinitions.smart_luggage : false;
    let showOptionsWording = true;
    if (!travelDispute && !endSupplier && !smartLuggage) {
      showOptionsWording = false;
    }

    return (
      <div className="policy-upgrades-container">
        {
          showOptionsWording &&
          <p>
            Would you like to add the following options to your cover:
          </p>
        }
        {
          travelDispute &&
          <div className="travel-dispute-box">
            <div className="policy-upgrade-checkbox">
              <Field
                 checkboxValue="travelDispute"
                 name={metaPolicyUpgrade + '.travel_dispute'}
                 component={UpgradeOptionsCheckbox}
                 isGold={isGold}
                 options={[options?.travel_dispute]}
              />
            </div>
            <div>
              Travel Dispute -&nbsp;
              <strong>{product.isPremiumAdjusting ? '*' : displayCurrency(get(travelDispute, 'total'))}</strong> extra
              <InfoButton content={travelDisputeText ? travelDisputeText.main : ''} />
            </div>
          </div>
        }
        {
          endSupplier &&
          <div className="travel-dispute-box">
            <div className="policy-upgrade-checkbox">
              <Field
                 checkboxValue="travelDispute2"
                 name={metaPolicyUpgrade + '.end_supplier_failure'}
                 component={UpgradeOptionsCheckbox}
                 isGold={isGold}
                 options={[options?.end_supplier_failure]}
              />
            </div>
            <div>
              End Supplier Failure -&nbsp;
              <strong>{product.isPremiumAdjusting ? '*' : displayCurrency(get(endSupplier, 'total'))}</strong> extra
              <InfoButton content={endSupplierText ? endSupplierText.main : ''} />
            </div>
          </div>
        }
        {
          smartLuggage &&
          <div className="travel-dispute-box">
            <div className="policy-upgrade-checkbox">
              <Field
                 checkboxValue="travelDispute3"
                 name={metaPolicyUpgrade + '.smart_luggage'}
                 component={UpgradeOptionsCheckbox} isGold={isGold}
                 options={[options?.smart_luggage]}
              />
            </div>
            <div>
              Smart luggage -&nbsp;
              <strong>{product.isPremiumAdjusting ? '*' : displayCurrency(get(smartLuggage, 'total'))}</strong> extra
              <InfoButton content={smartLuggageText ? smartLuggageText.main : ''}/>
            </div>
          </div>
        }
      </div>
    );
  }
}
